import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import categoryreducer, {fetchPcategories} from "../../../reduxLib/pcategoriesLib";

function Categories(props) {

    const [index, setIndex] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pcategoriesList,setPcategoriesList]=useState([]);
    const state=useSelector((state)=> state.categoryreducer.state);
    const categories= useSelector((state)=> state.categoryreducer.pcategoriesList);
    const [selectedCategory, setSelectedCategory] = useState({
        id: 0,
        name: "All Products",
    });


    useEffect(()=>{

        if(!categories || categories.length === 0) {
            // Fetch the event by ID when the component mounts or when the id changes
           dispatch(fetchPcategories()).then((action) => {
               // Once the action is fulfilled, set the eventprofile state
               if (action.payload) {
                   setPcategoriesList(action.payload);
                   console.log("playload ", action.payload);
                   console.log("playload E", pcategoriesList);
               }
           });
        }
        else {
            //let f=events.filter((event) => event.ownerid === id);
            // If the event data is already available, set the eventprofile state

            setPcategoriesList(categories);
            console.log("not disp ",pcategoriesList);
        }
    }, [dispatch,state]);

    const handleCategoryClick = (cat) => {
        props.onBreadcrumbChange([
            { label: "Home", to: "/products" },
            { label: cat.name, to: `/products/${cat.id}/1` },
        ]);
    };

    const selectCategory = (categoryId) => {
        setSelectedCategory((prev) => ({
            ...prev,
            id: categoryId,
        }));
        props.onCategoryChange(categoryId);
    };

    return (
        <div className="flex flex-wrap gap-3">
            <button onClick={() => {
                handleCategoryClick({id: 0, name: "All Products"});
                selectCategory(0);
            }}
                    className={
                        selectedCategory.id === 0
                            ? "category-active px-6 py-2 rounded-lg font-medium border-2 border-gray-300 text-gray-700 hover:border-custom-green transition-all"
                            : "px-6 py-2 rounded-lg font-medium border-2 border-gray-300 text-gray-700 hover:border-custom-green transition-all"
                    }>All
                Products
            </button>
            {
                pcategoriesList?.map((cat, index) => (
                    <button key={cat.id ?? index} onClick={() => {
                        handleCategoryClick({id: cat.categoryID, name: cat.name});
                        selectCategory(cat.categoryID);
                    }}
                            className={
                                selectedCategory.id === cat.categoryID
                                    ? "category-active px-6 py-2 rounded-lg font-medium border-2 border-gray-300 text-gray-700 hover:border-custom-green transition-all"
                                    : "px-6 py-2 rounded-lg font-medium border-2 border-gray-300 text-gray-700 hover:border-custom-green transition-all"
                            }>
                        {pcategoriesList[index].name}

                    </button>
                ))}
        </div>
    );
}

export default Categories;